import { trackEvent } from '@/segmentAnalytics/core'

export const trackGDPRAcceptTap = (): void => {
  trackEvent('gdpr_accept_tap')
}